import { useCallback, useState } from 'react'

import i18n from './i18n'
import css from './index.module.css'

import { Result } from '#/local/component/Result'

import { useSearchResult } from '#/local/hook/useSearchResult'

import { Input } from '#/global/component/Form/Input'
import { Svg } from '#/global/component/Image/Svg'

import { useDebounce } from '#/global/hook/useDebounce'

import { Config } from '#/global/helper/Config'

/**
 * Zpoždění mezi jednotlivými změnami v inputu. Pokud do tohoto času zadám nový znak, nezavolá se funkce pro získání výsledků.
 */
const DEBOUNCE_DELAY = 150

/**
 * URL adresa na eshopu pro zobrazení LP vyhledávání
 */
const SEARCH_PAGE_URL = '/search/'

export const App = () => {
    const [query, setQuery] = useState('')
    const [isResultOpen, setIsResultOpen] = useState(false)

    const debouncedQuery = useDebounce(query, DEBOUNCE_DELAY)

    const searchResult = useSearchResult(debouncedQuery)

    const t = i18n[Config.getLang()]

    const hasResults = searchResult.isSuccess && Object.values(searchResult.data).reduce((total, value) => total + value.length, 0) > 0
    const showResult = isResultOpen && query.length > 0 && hasResults

    const searchPageUrl = `${SEARCH_PAGE_URL}?query=${query}`

    /**
     * Pokud zmáčknu Enter, přejdu na stránku s výsledky vyhledávání.
     */
    const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            window.location.href = searchPageUrl
        }
    }, [searchPageUrl])

    const onClose = useCallback(() => {
        setIsResultOpen(false)
    }, [])

    const onFocus = useCallback(() => {
        setIsResultOpen(true)
    }, [])

    return (
        <div className={`r-a-search-bar ${css.wrap}`}>
            <Input
                aria-autocomplete="none"
                aria-expanded={isResultOpen}
                aria-haspopup="listbox"
                aria-label={t.search}
                autoComplete="off"
                className={css.input}
                onChange={setQuery}
                onFocus={onFocus}
                onKeyDown={handleKeyDown}
                placeholder={t.placeholder}
                role="textbox"
                type="search"
                value={query}
            />
            <a aria-label={t.search} className={`${css.submit} dek-button-red`} href={searchPageUrl} role="button">
                <Svg src="/file/search-e6887500.svg" alt={t.search} />
            </a>
            {showResult && (
                <Result
                    onClose={onClose}
                    query={query}
                    searchResults={searchResult.data}
                />
            )}
        </div>
    )
}
